module.exports = __webpack_public_path__ + "img/pauline_seidel.9c1c0787.jpeg";